export default __webpack_public_path__ + "static/media/arrow-forward.0f63992f.svg";